import React, { ImgHTMLAttributes } from 'react';

export interface StaticImageData {
  src: string;
  height: number;
  width: number;
  blurDataURL?: string;
}

interface OptimizedImageProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height'
> {
  src: string | StaticImageData;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  quality?: number;
  fill?: boolean;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  priority,
  fill,
  className,
  style,
  ...props
}) => {
  const imageSrc = typeof src === 'string' ? src : src.src;

  const fillStyles = fill
    ? {
        position: 'absolute' as const,
        width: '100%',
        height: '100%',
        inset: 0,
      }
    : {};

  return (
    <img
      src={imageSrc}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      loading={priority ? 'eager' : 'lazy'}
      className={className}
      style={{ ...fillStyles, ...style }}
      {...props}
    />
  );
};
